import React from "react";import { PAGE_URL, USER_ROLES } from "../../../utils";

import { DataIcon, HomeIcon, ServiceStatusIcon, InsightIcon } from "../../../assets/icons";
import { AuditOutlined, DatabaseOutlined } from "@ant-design/icons";

const USER_LEFT_MENU_FOOTER_ITEMS: ILeftMenuItem[] = [
  // { link: PAGE_URL.SETTINGS, icon: <SettingsIcon />, title: "Settings" },
];

export const getAppMenuItems = (roleCode: string) => {
  const menuItems: ILeftMenuItem[] = [
    { link: PAGE_URL.STATUS, icon: <HomeIcon />, title: "Dashboard" },
    { link: PAGE_URL.DOCUMENTS, icon: <DataIcon />, title: "Documents" },
  ];

  menuItems.push(
    { link: PAGE_URL.FEEDBACK, icon: <InsightIcon />, title: "Feedback Insights" },
    { link: PAGE_URL.FEEDBACKS, icon: <AuditOutlined />, title: "Feedback" }
  );

  if (roleCode === USER_ROLES.SUPER_ADMIN) {
    menuItems.push({ link: PAGE_URL.OTHERS, icon: <DatabaseOutlined />, title: "Others" });
  }

  return menuItems;
};

export const getAppFooterMenuItems = (roleCode: string) => {
  return USER_LEFT_MENU_FOOTER_ITEMS;
}
